// RdYlBu diverging colour ramp (inverted: cold=blue → neutral=yellow → hot=red)
// 5 stops at t = 0, 0.25, 0.5, 0.75, 1.0
const redYellowBlueRampData = [
    [0x31, 0x36, 0x95], // 0.00 – deep blue  (#313695)
    [0x74, 0xad, 0xd1], // 0.25 – light blue (#74add1)
    [0xff, 0xff, 0xbf], // 0.50 – pale yellow (#ffffbf)
    [0xf4, 0x6d, 0x43], // 0.75 – orange     (#f46d43)
    [0xa5, 0x00, 0x26], // 1.00 – deep red   (#a50026)
];
/** Linearly interpolate between the 5 ramp stops. */
function getRGBColorForValue_redYellowBlueRamp(scaledValue) {
    const clamped = Math.max(0, Math.min(1, scaledValue));
    const segment = clamped * (redYellowBlueRampData.length - 1);
    const lo = Math.floor(segment);
    const hi = Math.min(lo + 1, redYellowBlueRampData.length - 1);
    const f = segment - lo;
    return [
        Math.round(redYellowBlueRampData[lo][0] + f * (redYellowBlueRampData[hi][0] - redYellowBlueRampData[lo][0])),
        Math.round(redYellowBlueRampData[lo][1] + f * (redYellowBlueRampData[hi][1] - redYellowBlueRampData[lo][1])),
        Math.round(redYellowBlueRampData[lo][2] + f * (redYellowBlueRampData[hi][2] - redYellowBlueRampData[lo][2])),
    ];
}
/** Linear black→white ramp. */
function getRGBColorForValue_greyscaleRamp(scaledValue) {
    const v = 255 - Math.round(Math.max(0, Math.min(1, scaledValue)) * 255);
    return [v, v, v];
}
// Spectral diverging colour ramp (ColorBrewer "Spectral", 7 stops)
// Ordered from low (deep red) to high (deep purple), bright yellow in the middle.
const spectralRampData = [
    [0xd7, 0x19, 0x1c], // 0.00 – deep red    (#d7191c)
    [0xfd, 0xae, 0x61], // 0.17 – orange      (#fdae61)
    [0xff, 0xff, 0xbf], // 0.33 – pale yellow (#ffffbf)
    [0xa6, 0xd9, 0x6a], // 0.50 – light green (#a6d96a)
    [0x1a, 0x96, 0x41], // 0.67 – green       (#1a9641)
    [0x66, 0xc2, 0xa5], // 0.83 – teal        (#66c2a5)
    [0x5e, 0x4f, 0xa2], // 1.00 – deep purple (#5e4fa2)
];
/** Linearly interpolate between the 7 spectral ramp stops. */
function getRGBColorForValue_spectralRamp(scaledValue) {
    const clamped = Math.max(0, Math.min(1, scaledValue));
    const segment = clamped * (spectralRampData.length - 1);
    const lo = Math.floor(segment);
    const hi = Math.min(lo + 1, spectralRampData.length - 1);
    const f = segment - lo;
    return [
        Math.round(spectralRampData[lo][0] + f * (spectralRampData[hi][0] - spectralRampData[lo][0])),
        Math.round(spectralRampData[lo][1] + f * (spectralRampData[hi][1] - spectralRampData[lo][1])),
        Math.round(spectralRampData[lo][2] + f * (spectralRampData[hi][2] - spectralRampData[lo][2])),
    ];
}
const colorFunctionsMap = {
    "red-yellow-blue": getRGBColorForValue_redYellowBlueRamp,
    "greyscale": getRGBColorForValue_greyscaleRamp,
    "spectral": getRGBColorForValue_spectralRamp,
};
/**
 * Returns the color function for the passed name. A color function maps a scaled value in [0, 1] to an RGB color.
 * If the name is not found, a default color function (red-yellow-blue ramp) is returned.
 */
export function getColorFunction(name) {
    return colorFunctionsMap[name] ?? getRGBColorForValue_redYellowBlueRamp;
}
